import { ReactNode } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  '@global': {
    html: {
      height: '100vh!important',
    },
  },
  layout: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto 1fr',
    gridTemplateAreas: '"head" "body" "foot"',
    height: '100%',
    width: '100%',
    padding: 16,
    position: 'fixed',
    inset: 0,
    overflow: 'hidden',
  }
});

function Layout({ children }: { children: ReactNode }) {
  const classes = useStyles();

  return (
    <div className={classes.layout}>
      {children}
    </div>
  );
}


export default Layout;
